import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import Button from '../../shared/TailwindComponents/Button';
import VerifyButton from './StripeVerificationButton';
import { loadStripe } from '@stripe/stripe-js';
const stripeKey = process.env.REACT_APP_STRIPE_KEY || ''
const stripePromise = loadStripe(stripeKey);

const SecuritySettings: React.FC = () => {
  const { t } = useTranslation();

  const [emailLoading, setEmailLoading] = useState(false);

  const userInfo = useSelector((state: RootState) => state.user.userInfo);

  const handleEmailVerification = async () => {
    setEmailLoading(true);
    setEmailLoading(false);
  };

  return (
    <div className="divide-y divide-gray-200 dark:divide-gray-700 px-2">
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 py-16 md:grid-cols-3">
        <div className="px-4 sm:px-6 md:px-0">
          <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-white">
            {t('Two-Factor Authentication (2FA)')}
          </h2>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            {t("Enhance your account security with Two-Factor Authentication.")}
          </p>

        </div>
        <div className="md:col-span-2">
          <div className="flex items-center justify-between bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
            <div>
              <p className="font-medium text-gray-900 dark:text-white">
                {t('Two-Factor Authentication')}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 italic">
                {t('Activate 2FA to safeguard your account with secure, multi-step verification.')}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 py-16 md:grid-cols-3">
        <div className="px-4 sm:px-6 md:px-0">
          <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-white">
            {t('Verification Options')}
          </h2>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            {t("Secure your account and unlock full platform features through identity and email verification.")}
          </p>
        </div>
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center justify-between bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
            <div>
              <p className="font-medium text-gray-900 dark:text-white">
                {t('Identity Verification')}
              </p> ̰
              <p className="text-xs text-gray-700 dark:text-gray-300">
                {t('Verify your identity to meet compliance standards and ensure secure access to the platform. Powered by Stripe, we ensure a seamless and secure process.')}
              </p>
            </div>
            {
              userInfo.IsVerified ? (
                <Button variant="primary" size='small'>
                  {t('Verified')}
                </Button>
              ) : (<VerifyButton stripePromise={stripePromise} />)
            }

          </div>

          <div className="flex items-center justify-between bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
            <div>
              <p className="font-medium text-gray-900 dark:text-white">
                {t('Email Verification')}
              </p>
              <p className="text-xs text-gray-700 dark:text-gray-300">
                {t('Confirm your email address to enable account recovery and receive important updates.')}
              </p>
            </div>
            {
              userInfo.isEmailVerified ? (
                <Button size='small' variant="primary">
                  {t('Verified')}
                </Button>
              ) : (
                <Button
                  variant="primary"
                  size='small'
                  onClick={handleEmailVerification}
                  disabled={emailLoading}
                >
                  {t('Verify')}
                  {emailLoading && <ClipLoader color="#fff" size={10} className="ml-2" />}
                </Button>)
            }

          </div>

        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
